/**
 * MEIA generated DTO enums are emitted per-DTO by the swagger codegen, so the
 * Create / Update variants of the same field are nominally distinct enum types
 * (with identical string values). These records bridge between them so MoS /
 * MoE / MoP authoring forms can stay typed against the Create enums while still
 * calling the Update mutations.
 */
import {
  ConfidenceTier,
  RedForceActivityProvenanceSource,
  StudyMissionStatus,
  StudyMoeCreateDtoAggregationMethodEnum,
  StudyMoeCreateDtoBlockingYellowBehaviorEnum,
  StudyMoeCreateDtoPendingMopBehaviorEnum,
  StudyMoeCreateDtoYellowDispositionEnum,
  StudyMoeSelectDtoAggregationMethodEnum,
  StudyMoeSelectDtoBlockingYellowBehaviorEnum,
  StudyMoeSelectDtoPendingMopBehaviorEnum,
  StudyMoeSelectDtoYellowDispositionEnum,
  StudyMoeUpdateDtoAggregationMethodEnum,
  StudyMoeUpdateDtoBlockingYellowBehaviorEnum,
  StudyMoeUpdateDtoPendingMopBehaviorEnum,
  StudyMoeUpdateDtoYellowDispositionEnum,
  StudyMopCreateDtoCategoryEnum,
  StudyMopCreateDtoDirectionEnum,
  StudyMopSelectDtoCategoryEnum,
  StudyMopSelectDtoDirectionEnum,
  StudyMopUpdateDtoCategoryEnum,
  StudyMopUpdateDtoDirectionEnum,
  StudyThreadCreateDtoKillChainCategoryEnum,
  StudyThreadSelectDtoKillChainCategoryEnum,
  StudyThreadUpdateDtoKillChainCategoryEnum,
} from '@@types/api.types';

const classificationLevelLabels: Record<string, string> = {
  CUI: 'CUI',
  SECRET: 'Secret',
  TOP_SECRET: 'Top Secret',
  UNCLASSIFIED: 'Unclassified',
};

const confidenceTierLabels: Record<ConfidenceTier, string> = {
  [ConfidenceTier.A]: 'Conf A',
  [ConfidenceTier.B]: 'Conf B',
  [ConfidenceTier.C]: 'Conf C',
  [ConfidenceTier.D]: 'Conf D',
  [ConfidenceTier.F]: 'Conf F',
};

const moeAggregationUpdateByCreate: Record<
  StudyMoeCreateDtoAggregationMethodEnum,
  StudyMoeUpdateDtoAggregationMethodEnum
> = {
  [StudyMoeCreateDtoAggregationMethodEnum.HYBRID]: StudyMoeUpdateDtoAggregationMethodEnum.HYBRID,
  [StudyMoeCreateDtoAggregationMethodEnum.WEIGHTED_CONTRIBUTING]:
    StudyMoeUpdateDtoAggregationMethodEnum.WEIGHTED_CONTRIBUTING,
  [StudyMoeCreateDtoAggregationMethodEnum.WORST_CASE_BLOCKING]:
    StudyMoeUpdateDtoAggregationMethodEnum.WORST_CASE_BLOCKING,
};

const moeBlockingUpdateByCreate: Record<
  StudyMoeCreateDtoBlockingYellowBehaviorEnum,
  StudyMoeUpdateDtoBlockingYellowBehaviorEnum
> = {
  [StudyMoeCreateDtoBlockingYellowBehaviorEnum.IGNORE]: StudyMoeUpdateDtoBlockingYellowBehaviorEnum.IGNORE,
  [StudyMoeCreateDtoBlockingYellowBehaviorEnum.PROPAGATE_YELLOW]:
    StudyMoeUpdateDtoBlockingYellowBehaviorEnum.PROPAGATE_YELLOW,
};

const moePendingUpdateByCreate: Record<
  StudyMoeCreateDtoPendingMopBehaviorEnum,
  StudyMoeUpdateDtoPendingMopBehaviorEnum
> = {
  [StudyMoeCreateDtoPendingMopBehaviorEnum.BLOCK_SCORING]: StudyMoeUpdateDtoPendingMopBehaviorEnum.BLOCK_SCORING,
  [StudyMoeCreateDtoPendingMopBehaviorEnum.EXCLUDE_FROM_AVERAGE]:
    StudyMoeUpdateDtoPendingMopBehaviorEnum.EXCLUDE_FROM_AVERAGE,
  [StudyMoeCreateDtoPendingMopBehaviorEnum.TREAT_AS_RED]: StudyMoeUpdateDtoPendingMopBehaviorEnum.TREAT_AS_RED,
  [StudyMoeCreateDtoPendingMopBehaviorEnum.TREAT_AS_YELLOW]: StudyMoeUpdateDtoPendingMopBehaviorEnum.TREAT_AS_YELLOW,
};

const moeYellowUpdateByCreate: Record<StudyMoeCreateDtoYellowDispositionEnum, StudyMoeUpdateDtoYellowDispositionEnum> =
  {
    [StudyMoeCreateDtoYellowDispositionEnum.ACCEPT]: StudyMoeUpdateDtoYellowDispositionEnum.ACCEPT,
    [StudyMoeCreateDtoYellowDispositionEnum.ACCEPT_WITH_OVERRIDE]:
      StudyMoeUpdateDtoYellowDispositionEnum.ACCEPT_WITH_OVERRIDE,
    [StudyMoeCreateDtoYellowDispositionEnum.REJECT]: StudyMoeUpdateDtoYellowDispositionEnum.REJECT,
  };

const mopCategoryUpdateByCreate: Record<StudyMopCreateDtoCategoryEnum, StudyMopUpdateDtoCategoryEnum> = {
  [StudyMopCreateDtoCategoryEnum.PROCESS_RELIABILITY]: StudyMopUpdateDtoCategoryEnum.PROCESS_RELIABILITY,
  [StudyMopCreateDtoCategoryEnum.TECHNICAL_PHYSICAL]: StudyMopUpdateDtoCategoryEnum.TECHNICAL_PHYSICAL,
  [StudyMopCreateDtoCategoryEnum.TIME_LATENCY]: StudyMopUpdateDtoCategoryEnum.TIME_LATENCY,
};

const mopDirectionUpdateByCreate: Record<StudyMopCreateDtoDirectionEnum, StudyMopUpdateDtoDirectionEnum> = {
  [StudyMopCreateDtoDirectionEnum.HIGHER_IS_BETTER]: StudyMopUpdateDtoDirectionEnum.HIGHER_IS_BETTER,
  [StudyMopCreateDtoDirectionEnum.LOWER_IS_BETTER]: StudyMopUpdateDtoDirectionEnum.LOWER_IS_BETTER,
};

const threadKillChainLabels: Record<string, string> = {
  [StudyThreadSelectDtoKillChainCategoryEnum.C2]: 'C2',
  [StudyThreadSelectDtoKillChainCategoryEnum.COUNTER_UAS]: 'cUAS',
  [StudyThreadSelectDtoKillChainCategoryEnum.CUSTOM]: 'Custom',
  [StudyThreadSelectDtoKillChainCategoryEnum.CYBER]: 'Cyber',
  [StudyThreadSelectDtoKillChainCategoryEnum.D3A]: 'D3A',
  [StudyThreadSelectDtoKillChainCategoryEnum.F2T2EA]: 'F2T2EA',
  [StudyThreadSelectDtoKillChainCategoryEnum.ISR]: 'ISR',
  [StudyThreadSelectDtoKillChainCategoryEnum.LOGISTICS]: 'Logistics',
};

const studyAdversaryProfileLabels: Record<string, string> = {
  CYBER_ACTOR: 'Cyber Actor',
  HYBRID_THREAT: 'Hybrid Threat',
  NEAR_PEER_EUROPEAN: 'Near-peer European',
  NEAR_PEER_PACIFIC: 'Near-peer Pacific',
  NON_STATE_ACTOR: 'Non-state Actor',
  PROXY_FORCE: 'Proxy Force',
  REGIONAL_POWER: 'Regional Power',
  UNATTRIBUTED: 'Unattributed',
};

const studyTimeHorizonLabels: Record<string, string> = {
  FAR_TERM_FY36_PLUS: 'Far-term (FY36+)',
  FYDP_FY28_30: 'FYDP (FY28-30)',
  MID_TERM_FY31_35: 'Mid-term (FY31-35)',
  NEAR_TERM_FY26_27: 'Near-term (FY26-27)',
};

const redForceActivityProvenanceSourceLabels: Record<RedForceActivityProvenanceSource, string> = {
  [RedForceActivityProvenanceSource.Admin]: 'Admin',
  [RedForceActivityProvenanceSource.IntelPkg]: 'Intel package',
  [RedForceActivityProvenanceSource.JLLIS]: 'JLLIS',
  [RedForceActivityProvenanceSource.Sme]: 'SME',
  [RedForceActivityProvenanceSource.User]: 'User',
};

const studyMissionStatusLabels: Record<StudyMissionStatus, string> = {
  [StudyMissionStatus.ACTIVE]: 'Active',
  [StudyMissionStatus.CLOSED]: 'Closed',
  [StudyMissionStatus.DRAFT]: 'Draft',
  [StudyMissionStatus.UNDER_REVIEW]: 'Under Review',
};

export const getStudyThreadKillChainLabel = (value: string): string => threadKillChainLabels[value] ?? value;

export const getClassificationLevelLabel = (value: string): string => classificationLevelLabels[value] ?? value;

export const getConfidenceTierLabel = (value: ConfidenceTier): string => confidenceTierLabels[value];

export const getRedForceActivityProvenanceSourceLabel = (value: RedForceActivityProvenanceSource): string =>
  redForceActivityProvenanceSourceLabels[value];

export const getStudyAdversaryProfileLabel = (value: string): string => studyAdversaryProfileLabels[value] ?? value;

export const getStudyMissionStatusLabel = (value: StudyMissionStatus): string => studyMissionStatusLabels[value];

export const getStudyTimeHorizonLabel = (value?: string | null): string => {
  if (!value) return '';
  return studyTimeHorizonLabels[value] ?? value;
};

export const toUpdateMoeAggregation = (
  value: StudyMoeCreateDtoAggregationMethodEnum,
): StudyMoeUpdateDtoAggregationMethodEnum => moeAggregationUpdateByCreate[value];

export const toUpdateMoeBlocking = (
  value: StudyMoeCreateDtoBlockingYellowBehaviorEnum,
): StudyMoeUpdateDtoBlockingYellowBehaviorEnum => moeBlockingUpdateByCreate[value];

export const toUpdateMoePending = (
  value: StudyMoeCreateDtoPendingMopBehaviorEnum,
): StudyMoeUpdateDtoPendingMopBehaviorEnum => moePendingUpdateByCreate[value];

export const toUpdateMoeYellow = (
  value: StudyMoeCreateDtoYellowDispositionEnum,
): StudyMoeUpdateDtoYellowDispositionEnum => moeYellowUpdateByCreate[value];

export const toUpdateMopCategory = (value: StudyMopCreateDtoCategoryEnum): StudyMopUpdateDtoCategoryEnum =>
  mopCategoryUpdateByCreate[value];

export const toUpdateMopDirection = (value: StudyMopCreateDtoDirectionEnum): StudyMopUpdateDtoDirectionEnum =>
  mopDirectionUpdateByCreate[value];

const moeAggregationCreateBySelect: Record<
  StudyMoeSelectDtoAggregationMethodEnum,
  StudyMoeCreateDtoAggregationMethodEnum
> = {
  [StudyMoeSelectDtoAggregationMethodEnum.HYBRID]: StudyMoeCreateDtoAggregationMethodEnum.HYBRID,
  [StudyMoeSelectDtoAggregationMethodEnum.WEIGHTED_CONTRIBUTING]:
    StudyMoeCreateDtoAggregationMethodEnum.WEIGHTED_CONTRIBUTING,
  [StudyMoeSelectDtoAggregationMethodEnum.WORST_CASE_BLOCKING]:
    StudyMoeCreateDtoAggregationMethodEnum.WORST_CASE_BLOCKING,
};

const moeBlockingCreateBySelect: Record<
  StudyMoeSelectDtoBlockingYellowBehaviorEnum,
  StudyMoeCreateDtoBlockingYellowBehaviorEnum
> = {
  [StudyMoeSelectDtoBlockingYellowBehaviorEnum.IGNORE]: StudyMoeCreateDtoBlockingYellowBehaviorEnum.IGNORE,
  [StudyMoeSelectDtoBlockingYellowBehaviorEnum.PROPAGATE_YELLOW]:
    StudyMoeCreateDtoBlockingYellowBehaviorEnum.PROPAGATE_YELLOW,
};

const moePendingCreateBySelect: Record<
  StudyMoeSelectDtoPendingMopBehaviorEnum,
  StudyMoeCreateDtoPendingMopBehaviorEnum
> = {
  [StudyMoeSelectDtoPendingMopBehaviorEnum.BLOCK_SCORING]: StudyMoeCreateDtoPendingMopBehaviorEnum.BLOCK_SCORING,
  [StudyMoeSelectDtoPendingMopBehaviorEnum.EXCLUDE_FROM_AVERAGE]:
    StudyMoeCreateDtoPendingMopBehaviorEnum.EXCLUDE_FROM_AVERAGE,
  [StudyMoeSelectDtoPendingMopBehaviorEnum.TREAT_AS_RED]: StudyMoeCreateDtoPendingMopBehaviorEnum.TREAT_AS_RED,
  [StudyMoeSelectDtoPendingMopBehaviorEnum.TREAT_AS_YELLOW]: StudyMoeCreateDtoPendingMopBehaviorEnum.TREAT_AS_YELLOW,
};

const moeYellowCreateBySelect: Record<StudyMoeSelectDtoYellowDispositionEnum, StudyMoeCreateDtoYellowDispositionEnum> =
  {
    [StudyMoeSelectDtoYellowDispositionEnum.ACCEPT]: StudyMoeCreateDtoYellowDispositionEnum.ACCEPT,
    [StudyMoeSelectDtoYellowDispositionEnum.ACCEPT_WITH_OVERRIDE]:
      StudyMoeCreateDtoYellowDispositionEnum.ACCEPT_WITH_OVERRIDE,
    [StudyMoeSelectDtoYellowDispositionEnum.REJECT]: StudyMoeCreateDtoYellowDispositionEnum.REJECT,
  };

const mopCategoryCreateBySelect: Record<StudyMopSelectDtoCategoryEnum, StudyMopCreateDtoCategoryEnum> = {
  [StudyMopSelectDtoCategoryEnum.PROCESS_RELIABILITY]: StudyMopCreateDtoCategoryEnum.PROCESS_RELIABILITY,
  [StudyMopSelectDtoCategoryEnum.TECHNICAL_PHYSICAL]: StudyMopCreateDtoCategoryEnum.TECHNICAL_PHYSICAL,
  [StudyMopSelectDtoCategoryEnum.TIME_LATENCY]: StudyMopCreateDtoCategoryEnum.TIME_LATENCY,
};

const mopDirectionCreateBySelect: Record<StudyMopSelectDtoDirectionEnum, StudyMopCreateDtoDirectionEnum> = {
  [StudyMopSelectDtoDirectionEnum.HIGHER_IS_BETTER]: StudyMopCreateDtoDirectionEnum.HIGHER_IS_BETTER,
  [StudyMopSelectDtoDirectionEnum.LOWER_IS_BETTER]: StudyMopCreateDtoDirectionEnum.LOWER_IS_BETTER,
};

export const toCreateMoeAggregation = (
  value: StudyMoeSelectDtoAggregationMethodEnum,
): StudyMoeCreateDtoAggregationMethodEnum => moeAggregationCreateBySelect[value];

export const toCreateMoeBlocking = (
  value: StudyMoeSelectDtoBlockingYellowBehaviorEnum,
): StudyMoeCreateDtoBlockingYellowBehaviorEnum => moeBlockingCreateBySelect[value];

export const toCreateMoePending = (
  value: StudyMoeSelectDtoPendingMopBehaviorEnum,
): StudyMoeCreateDtoPendingMopBehaviorEnum => moePendingCreateBySelect[value];

export const toCreateMoeYellow = (
  value: StudyMoeSelectDtoYellowDispositionEnum,
): StudyMoeCreateDtoYellowDispositionEnum => moeYellowCreateBySelect[value];

export const toCreateMopCategory = (value: StudyMopSelectDtoCategoryEnum): StudyMopCreateDtoCategoryEnum =>
  mopCategoryCreateBySelect[value];

export const toCreateMopDirection = (value: StudyMopSelectDtoDirectionEnum): StudyMopCreateDtoDirectionEnum =>
  mopDirectionCreateBySelect[value];

const threadKillChainCreateBySelect: Record<
  StudyThreadSelectDtoKillChainCategoryEnum,
  StudyThreadCreateDtoKillChainCategoryEnum
> = {
  [StudyThreadSelectDtoKillChainCategoryEnum.C2]: StudyThreadCreateDtoKillChainCategoryEnum.C2,
  [StudyThreadSelectDtoKillChainCategoryEnum.COUNTER_UAS]: StudyThreadCreateDtoKillChainCategoryEnum.COUNTER_UAS,
  [StudyThreadSelectDtoKillChainCategoryEnum.CUSTOM]: StudyThreadCreateDtoKillChainCategoryEnum.CUSTOM,
  [StudyThreadSelectDtoKillChainCategoryEnum.CYBER]: StudyThreadCreateDtoKillChainCategoryEnum.CYBER,
  [StudyThreadSelectDtoKillChainCategoryEnum.D3A]: StudyThreadCreateDtoKillChainCategoryEnum.D3A,
  [StudyThreadSelectDtoKillChainCategoryEnum.F2T2EA]: StudyThreadCreateDtoKillChainCategoryEnum.F2T2EA,
  [StudyThreadSelectDtoKillChainCategoryEnum.ISR]: StudyThreadCreateDtoKillChainCategoryEnum.ISR,
  [StudyThreadSelectDtoKillChainCategoryEnum.LOGISTICS]: StudyThreadCreateDtoKillChainCategoryEnum.LOGISTICS,
};

const threadKillChainUpdateByCreate: Record<
  StudyThreadCreateDtoKillChainCategoryEnum,
  StudyThreadUpdateDtoKillChainCategoryEnum
> = {
  [StudyThreadCreateDtoKillChainCategoryEnum.C2]: StudyThreadUpdateDtoKillChainCategoryEnum.C2,
  [StudyThreadCreateDtoKillChainCategoryEnum.COUNTER_UAS]: StudyThreadUpdateDtoKillChainCategoryEnum.COUNTER_UAS,
  [StudyThreadCreateDtoKillChainCategoryEnum.CUSTOM]: StudyThreadUpdateDtoKillChainCategoryEnum.CUSTOM,
  [StudyThreadCreateDtoKillChainCategoryEnum.CYBER]: StudyThreadUpdateDtoKillChainCategoryEnum.CYBER,
  [StudyThreadCreateDtoKillChainCategoryEnum.D3A]: StudyThreadUpdateDtoKillChainCategoryEnum.D3A,
  [StudyThreadCreateDtoKillChainCategoryEnum.F2T2EA]: StudyThreadUpdateDtoKillChainCategoryEnum.F2T2EA,
  [StudyThreadCreateDtoKillChainCategoryEnum.ISR]: StudyThreadUpdateDtoKillChainCategoryEnum.ISR,
  [StudyThreadCreateDtoKillChainCategoryEnum.LOGISTICS]: StudyThreadUpdateDtoKillChainCategoryEnum.LOGISTICS,
};

export const toCreateThreadKillChain = (
  value: StudyThreadSelectDtoKillChainCategoryEnum,
): StudyThreadCreateDtoKillChainCategoryEnum => threadKillChainCreateBySelect[value];

export const toUpdateThreadKillChain = (
  value: StudyThreadCreateDtoKillChainCategoryEnum,
): StudyThreadUpdateDtoKillChainCategoryEnum => threadKillChainUpdateByCreate[value];

// Generic SCREAMING_SNAKE_CASE / kebab-case enum value → Title Case display label.
// Used by the P5 Brief and other surfaces that need to surface raw enum values to users.
export const formatEnumLabel = (value?: string | null): string => {
  if (!value) return '-';
  return value
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .split(/[_\-\s]+/)
    .filter(Boolean)
    .map((word) => {
      if (/\d/.test(word)) return word.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};
